import * as React from 'react';
import * as moment from "moment";
import { Form, Text, Select, Checkbox, TextArea } from 'react-form';
import { SingleDatePicker } from 'react-dates';
import { api } from '@src/services/api';
import { _ } from "@src/services/i18n";
import { Switch } from '@src/services/form';
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoEdit, PropsEdit, StateEdit } from '@src/components/Proto';
import { Box, Modal } from '@src/components';

// typing
interface LocalProps extends PropsEdit {
    battid?: any;
}
interface LocalState extends StateEdit {
    date: any;
    focused: any;
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Maintenance extends ProtoEdit<LocalProps, LocalState> {

    localSave( v ) {
        v = {
            ...v,
            battid: this.props.battid,
            expiration: this.state.date.format('YYYY-MM-DD')
        };
        this.save(v);
    }

    postLoad( entity ) {
        const { expiration } = entity;
        this.setState({
            date: moment(expiration)
        })
    }

	// render
	render() {
        const loading = this.loading();
        if (loading) return null;
        const { id, onCancel } = this.props;
        const { data, values = {}, entity = null, error } = this.state;
        if (entity === null) return null;

        return (
            <Modal
                title={!id ? _('new_title', 'BatteryLife') : _('edit_title', 'BatteryLife', { name: entity.description } ) }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.localSave(v)}
                        defaultValues={ entity || null }
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="date">{_(`field_expiration`, 'BatteryLife')}</label>
                                    <SingleDatePicker
                                        id="date"
                                        date={this.state.date}
                                        onDateChange={date => this.setState({ date })}
                                        focused={this.state.focused}
                                        onFocusChange={({ focused }) => this.setState({ focused })} 
                                    />
                                </article>
                                <article className="switch">
                                    <label htmlFor="completed">{_(`field_completed`, 'BatteryLife')}</label>
                                    <Switch field="completed" id="completed" />
                                </article>
                                <article className="full">
                                    <label htmlFor="note">{_('field_note', 'BatteryLife')}</label>
                                    <TextArea field="note" id="note" className="form-control" rows={5} />
                                </article>
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                {_(`btn_cancel`, 'BatteryLife')}
                                </button>
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_save`, 'BatteryLife')} 
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/BatteryLife/MaintenanceEdit.tsx